import client from './client';

export const getReservationsPaginated = (params) =>
  client.get('/stock-reservations', { params }).then((r) => r.data);

export const getReservation = (uuid) =>
  client.get(`/stock-reservations/${uuid}`).then((r) => r.data);

export const createReservation = (data) =>
  client.post('/stock-reservations', data).then((r) => r.data);

export const releaseReservation = (uuid) =>
  client.delete(`/stock-reservations/${uuid}`).then((r) => r.data);

export const fulfillReservation = (uuid) =>
  client.post(`/stock-reservations/${uuid}/fulfill`).then((r) => r.data);

export const expireOldReservations = () =>
  client.post('/stock-reservations/expire-old').then((r) => r.data);
